// Het adres van een afbeelding netjes in elkaar zetten. (W8, 17-09-2026)
//
// Overal in de widgets stond hetzelfde stukje handwerk: het adres van het dashboard, een schuine
// streep, de map, en dan de bestandsnaam uit de database. Dat ging op twee plekken mis:
//
//   * het adres van het dashboard eindigt zelf al op een streep, dus werd het
//     https://dashboarddev.jimani.online//upload/Widgetsetup/...
//   * en de bestandsnaam uit de database begint vaak met een streep of met backslashes van Windows,
//     dus werd het .../upload/SalonTreatment//2026/March/foto.jpg
//
// Een dubbele streep is voor de meeste servers hetzelfde pad, maar niet voor alle -- en het staat in
// het logboek en in de bron van de pagina. Bovendien liep het telkens net anders per widget, wat het
// moeilijk maakte om te zien of een ontbrekende foto aan het pad lag of aan het bestand.
//
// Gebruik: beeldadres(afbeeldingAdres, 'upload/Widgetsetup', bestandsnaam)

export function beeldadres(...delen) {
    const schoon = delen
        .filter((deel) => deel !== null && deel !== undefined && deel !== '')
        .map((deel) => String(deel).replace(/\\/g, '/'))
        .map((deel, i) => (i === 0 ? deel.replace(/\/+$/, '') : deel.replace(/^\/+/, '').replace(/\/+$/, '')))
        .filter((deel) => deel !== '');

    return schoon.join('/');
}

export default beeldadres;
